// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import {
    AvailableResourceContainer,
    CircleProgressBar,
    CircleBackground,
    AvailableResourceCircleContent,
    AvailableResourceCircle,
    AvailableResourceCircleSvg,
} from 'admin/disasterRecovery/components/StartDisasterRecoveryModal/Styles';

export interface IAvailableResourceProps {
    progress: number;
    header: string | React.ReactNode;
    middle: string | React.ReactNode;
    footer: string | React.ReactNode;
    muted?: boolean;
}

export type AvailableResourceProps =
    IAvailableResourceProps;

export const AvailableResource: React.FC<AvailableResourceProps> = ({
    progress,
    header,
    footer,
    middle,
    muted,
}) => (
    <AvailableResourceContainer muted={muted}>
        <div>{header}</div>
        <AvailableResourceCircle width={100} height={100}>
            <AvailableResourceCircleSvg viewBox="0 0 100 100">
                <CircleBackground cx="50" cy="50" r="47" />
                <CircleProgressBar cx="50" cy="50" r="47" pathLength="100" strokeDasharray={progress + ' 100'}/>
            </AvailableResourceCircleSvg>
            <AvailableResourceCircleContent>
                <div>
                    {middle}
                </div>
                {footer}
            </AvailableResourceCircleContent>
        </AvailableResourceCircle>
    </AvailableResourceContainer>
);